import { render, staticRenderFns } from "./LoginHistory.vue?vue&type=template&id=b1dd23a6&scoped=true"
import script from "./LoginHistory.vue?vue&type=script&lang=js"
export * from "./LoginHistory.vue?vue&type=script&lang=js"
import style0 from "./LoginHistory.vue?vue&type=style&index=0&id=b1dd23a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dd23a6",
  null
  
)

export default component.exports